import React from 'react'
import { useProductListPage } from 'lib/modules/catalog'
import { Filter } from './components/Filter'
import { Container } from './styled'

interface Props {
  categoryId?: number
  onFilterChange?: () => void
}

export const LayeredNav = ({ categoryId, onFilterChange }: Props) => {
  const { isFetching, handleFilterChange, layeredNav } = useProductListPage({
    categoryId,
    onFilterChange,
    withLayeredNav: true
  })

  return (
    <Container
      isFetching={isFetching}
    >
      <div>
        {layeredNav?.appliedFilters && (
          <ul>
            {layeredNav?.filterOptions.map(item => {
              return (
                <Filter
                  key={item.code}
                  isFetching={isFetching}
                  filterOptions={item}
                  handleFilterChange={handleFilterChange}
                />
              )
            })}
          </ul>
        )}
      </div>
    </Container>
  )
}
